import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'dvr_types',
  title: "Типы Видеорегистраторов",
  apiType: apiTypes.REPORT_API,
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'name',
      title: 'Наименование',
      type: 'text',
      required: true,
      validate: (value: any) => /^[A-Za-z-А-Яа-я-0-9_-]+$/.test(value),
      validateError: 'Допустимы только буквы, цифры и знаки "_" и "-"',
      width: '30%',
      maxLengthValue: 255
    },
    {
      name: 'type_code',
      title: 'Код типа видеорегистратора',
      type: 'text',
      required: false,
      validate: (value: any) => /^[A-Za-z-0-9_-]+$/.test(value),
      validateError: 'Допустимы только буквы латинского алфавита, цифры и знаки "_" и "-"',
      width: '30%',
      maxLengthValue: 255
    },
    {
      name: 'version',
      title: 'Версия',
      type: 'text',
      required: false,
      //validate: (value: any) => /^[A-Za-z-0-9_-]+$/.test(value),
      //validateError: 'Допустимы только буквы латинского алфавита, цифры и знаки "_" и "-"',
      width: '30%',
      maxLengthValue: 255
    },
    {
      name: 'is_serial_number_identification',
      title: 'Идентификация по серийному номеру',
      type: 'boolean',
      required: false,
      width: '205px',
    }
  ],
  newTemplate: {
    id: null,
    name: null,
    type_code: null,
    version: null,
    is_serial_number_identification: false,
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc'
  },
  import: {
    header: [
      {
        title: 'model_id',
        field: 'id',
      },
      {
        title: 'model_name',
        field: 'name',
      },
      {
        title: 'software_type',
        field: 'type',
      },
      {
        title: 'software_version',
        field: 'version',
      }
    ],
    example: `1;MNT;mnt;2_0;false`,
  },

};

export default config;
